export class AccountNotFoundError extends Error {
  // This gives the error type safety
  private readonly typeName = 'AccountNotFoundError'
  public readonly name = this.typeName

  constructor(message?: string) {
    super(message || 'Account not found')
  }
}
